import { distanceToBeLoaded } from './distanceToBeLoaded';
import { hasMore } from './hasMore';

export const pagination = {
  hasMore,
  distanceToBeLoaded,
};
